(() => {
  const ROOT_SELECTOR = '[data-exo-product-trust-share]';

  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    if (root.dataset.socialReady === 'true') return;
    root.dataset.socialReady = 'true';

    const campaign = root.dataset.shareCampaign || 'exo_product_share';
    const eventPrefix = root.dataset.shareEventPrefix || 'product_share';
    const surface = root.dataset.shareSurface || 'exo_product_trust_hub';
    const releaseMode = root.dataset.shareMode === 'release';
    const anchor = root.id || 'exo-product-trust-hub';
    const isPrimaryHub = root === document.querySelector(ROOT_SELECTOR);
    const sharePanel = root.querySelector('[data-share-panel]');
    const statusNode = root.querySelector('[data-share-status]');
    const nativeButtons = root.querySelectorAll('[data-share-native]');
    const copyButtons = root.querySelectorAll('[data-share-copy]');
    const platformLinks = root.querySelectorAll('[data-share-platform]');

    const base = {
      productTitle: root.dataset.productTitle || document.title,
      productHandle: root.dataset.productHandle || '',
      productUrl: root.dataset.productUrl || window.location.href,
      imageUrl: root.dataset.productImage || '',
      shareText: root.dataset.shareText || '',
      designId: '',
      designTitle: '',
    };

    let active = { ...base };

    const cleanUrl = (value) => {
      const url = new URL(value, window.location.origin);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => url.searchParams.delete(key));
      return url;
    };

    const slug = (value) => String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'product';

    const trackedUrl = (platform) => {
      const useCurrentSelection = root.dataset.shareCurrentSelection === 'true' && new URL(active.productUrl, location.origin).pathname === location.pathname;
      const url = cleanUrl(useCurrentSelection ? location.href : active.productUrl);
      if (active.designId) url.searchParams.set('design', active.designId);
      url.searchParams.set('utm_source', platform);
      url.searchParams.set('utm_medium', 'social');
      url.searchParams.set('utm_campaign', active.autograph?'sign_the_flag':campaign);
      url.searchParams.set('utm_content', active.designId || slug(active.productHandle || active.productTitle));
      url.hash = useCurrentSelection ? '' : active.autograph ? '' : active.designId ? `gameday-design-${active.designId}` : anchor;
      return url.toString();
    };

    const shareTitle = () => active.designTitle
      ? `${active.designTitle}${releaseMode ? ' Authentic Gameday Flag' : ''}`
      : active.productTitle;

    const shareText = () => active.designTitle
      ? (releaseMode
        ? `Help the ${active.designTitle} Authentic Gameday Flag get noticed.`
        : `Take a look at ${active.designTitle}.`)
      : (active.shareText || (releaseMode
        ? `Help ${active.productTitle} get noticed.`
        : `Take a look at ${active.productTitle}.`));

    const publish = (name, platform, outcome = 'intent') => {
      const payload = {
        platform,
        outcome,
        product_handle: active.productHandle,
        design_id: active.designId,
        design_title: active.designTitle,
        surface,
        share_url: trackedUrl(platform),
      };
      try {
        if (window.Shopify?.analytics?.publish) {
          const result = window.Shopify.analytics.publish(`exo:${eventPrefix}_${name}`, payload);
          if (result?.catch) result.catch(() => {});
        }
      } catch (_) {}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `exo_${eventPrefix}_${name}`, ...payload });
    };

    const setStatus = (message) => {
      if (!statusNode) return;
      statusNode.textContent = message;
      window.clearTimeout(setStatus.timer);
      setStatus.timer = window.setTimeout(() => { statusNode.textContent = ''; }, 5200);
    };

    const copyText = async (value) => {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
      }
      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    };

    const platformHref = (platform) => {
      const url = trackedUrl(platform);
      const text = shareText();
      if (platform === 'facebook') return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
      if (platform === 'pinterest') {
        const media = active.imageUrl ? `&media=${encodeURIComponent(active.imageUrl)}` : '';
        return `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}${media}&description=${encodeURIComponent(text)}`;
      }
      if (platform === 'x') return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
      return url;
    };

    const refresh = () => {
      platformLinks.forEach((link) => {
        const platform = link.dataset.sharePlatform;
        link.href = platformHref(platform);
      });
    };

    if (root.dataset.shareCurrentSelection === 'true') {
      root.addEventListener('pointerenter', refresh);
      root.addEventListener('focusin', refresh);
      root.addEventListener('click', refresh, true);
      document.addEventListener('change', () => window.setTimeout(refresh, 0));
      window.addEventListener('popstate', refresh);
    }

    // Move the existing share controls into a native dialog; retain every original handler.
    let autographDialog,shareAnchor,shareReturnFocus,previousContext;
    const fullPost=platform=>shareText()+'\n\n'+trackedUrl(platform);
    const ensureAutographDialog=()=>{
      if(autographDialog)return autographDialog;
      const style=document.createElement('style');style.textContent=`.gameday-autograph-share{box-sizing:border-box;width:min(900px,calc(100% - 24px));max-height:84dvh;margin:auto;padding:0;overflow:auto;border:1px solid #536047;border-radius:12px;background:#191f19;color:#f5f7ee;font:14px/1.5 Arial,sans-serif}.gameday-autograph-share::backdrop{background:#06100b38;backdrop-filter:none}.gameday-autograph-share *{box-sizing:border-box}.gameday-autograph-share header{display:flex;gap:20px;align-items:start;justify-content:space-between;position:sticky;top:0;z-index:2;background:#191f19;padding:20px;border-bottom:1px solid #415038}.exo-product-trust__share .gameday-autograph-share h2{font:700 26px/1.1 Arial;margin:4px 0;letter-spacing:-.5px}.gameday-autograph-share header small{color:#bddb87;font-size:10px;letter-spacing:1.5px}.gameday-autograph-share button{cursor:pointer;font:700 12px/1.4 Arial}.gameday-autograph-share [data-share-close]{flex:0 0 40px;height:40px;background:transparent;border:1px solid #6e7c5c;color:white;font-size:26px}.gameday-autograph-share .share-body{display:grid;grid-template-columns:1fr 1.1fr;gap:22px;padding:22px}.gameday-autograph-share .share-preview{min-width:0}.gameday-autograph-share [data-share-preview-image]{width:100%;height:auto;aspect-ratio:4/3;object-fit:contain;background:#111711;border-radius:6px}.gameday-autograph-share .share-preview p{font-size:12px;color:#becbb4}.gameday-autograph-share [data-share-preview-destination]{display:block;color:#c7e842;font-size:12px;overflow-wrap:anywhere}.gameday-autograph-share .share-compose{min-width:0}.gameday-autograph-share .exo-product-trust__platforms{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px}.gameday-autograph-share .exo-product-trust__platforms a,.gameday-autograph-share .exo-product-trust__platforms button{padding:9px;min-height:64px;background:#263021;color:#fff;border:1px solid #4c5a41;text-decoration:none;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;gap:8px}.gameday-autograph-share .exo-product-trust__platforms small{display:block;font-size:9px}.gameday-autograph-share .exo-product-trust__social-icon{flex:0 0 25px;width:25px;height:25px}.gameday-autograph-share svg{width:25px;height:25px}.gameday-autograph-share .exo-product-trust__share-utility{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0}.gameday-autograph-share .exo-product-trust__share-utility button{display:flex;align-items:center;gap:6px;background:transparent;border:1px solid #526344;padding:8px;color:#fff}.gameday-autograph-share [data-share-status]{width:100%;font-size:12px;color:#c7e842}.gameday-autograph-share label{display:block;font-size:10px;letter-spacing:1px;margin-top:16px;color:#bdceab}.gameday-autograph-share textarea{display:block;width:100%;padding:12px;margin:7px 0 12px;border:1px solid #536a43;border-radius:5px;background:#0e160f;color:#f5f7ee;font:13px/1.5 Arial;resize:vertical}.gameday-autograph-share .share-post-actions{display:flex;flex-wrap:wrap;gap:8px}.gameday-autograph-share .share-post-actions button{background:#c7e842;border:0;color:#142013;padding:12px}.gameday-autograph-share :focus-visible{outline:2px solid #c7e842;outline-offset:3px}@media(max-width:650px){.gameday-autograph-share .share-body{grid-template-columns:1fr;padding:16px;gap:14px}.gameday-autograph-share .share-preview{display:grid;grid-template-columns:100px 1fr;gap:12px;align-items:center}.gameday-autograph-share .share-preview p{margin:4px 0}.exo-product-trust__share .gameday-autograph-share h2{font-size:22px}.gameday-autograph-share header{padding:16px}}`;
      document.head.append(style);autographDialog=document.createElement('dialog');autographDialog.className='gameday-autograph-share';autographDialog.dataset.shareDialog='';autographDialog.setAttribute('aria-label','Share this flag');
      autographDialog.innerHTML='<header><div><small>GAMEDAY FLAGS / BRING YOUR CROWD</small><h2 data-share-dialog-title></h2></div><button type="button" data-share-close aria-label="Close sharing options">×</button></header><div class="share-body"><aside class="share-preview"><img data-share-preview-image alt="Flag lifestyle share preview"><div><p data-share-message></p><a data-share-preview-destination target="_blank" rel="noopener">Open this flag ↗</a><p>Copy the caption and link, or open the image to make your post.</p></div></aside><div class="share-compose"><div data-share-controls></div><label>READY-TO-POST CAPTION<textarea data-share-caption readonly rows="5" aria-label="Post caption and flag link"></textarea></label><div class="share-post-actions"><button type="button" data-share-copy-post>Copy caption + link</button><button type="button" data-share-open-image>Open share image ↗</button></div></div></div>';
      root.append(autographDialog);autographDialog.querySelector('[data-share-close]').onclick=()=>autographDialog.close();
      autographDialog.addEventListener('close',()=>{if(shareAnchor?.isConnected)shareAnchor.replaceWith(sharePanel);selectContext(previousContext||{});if(shareReturnFocus?.isConnected)shareReturnFocus.focus({preventScroll:true});});
      autographDialog.querySelector('[data-share-copy-post]').onclick=async()=>{try{await copyText(fullPost('copy'));setStatus('Caption and flag link copied. Ready to paste into your post.');}catch{const c=autographDialog.querySelector('textarea');c.focus();c.select();setStatus('Select and copy the caption above.');}};
      autographDialog.querySelector('[data-share-open-image]').onclick=()=>window.open(active.imageUrl,'_blank','noopener,noreferrer');
      return autographDialog;
    };
    if(isPrimaryHub)document.addEventListener('gameday-share-open',event=>{
      if(event.detail?.productHandle!==base.productHandle||!sharePanel)return;
      let image;try{image=new URL(event.detail.imageUrl,location.href);}catch{return;}
      if(image.protocol!=='https:'||!['exolox.com','www.exolox.com','cdn.shopify.com'].includes(image.hostname))return;
      event.preventDefault();const dialog=ensureAutographDialog();if(dialog.open)return;previousContext={...active};shareReturnFocus=document.activeElement;
      selectContext({autograph:true,imageUrl:image.href,shareText:String(event.detail.productDescription||'').slice(0,500)});
      dialog.querySelector('[data-share-dialog-title]').textContent=shareTitle();dialog.querySelector('[data-share-message]').textContent=shareText();dialog.querySelector('[data-share-preview-image]').src=image.href;dialog.querySelector('[data-share-preview-destination]').href=trackedUrl('preview');dialog.querySelector('[data-share-caption]').value=fullPost('copy');
      shareAnchor=document.createComment('Original product share controls');sharePanel.before(shareAnchor);dialog.querySelector('[data-share-controls]').append(sharePanel);setStatus('');dialog.showModal();publish('panel_opened','autograph');
    });

    const cardContext = (button) => {
      const article = button.closest('article');
      const designImage = article?.querySelector('img');
      const designId = button.dataset.designId || article?.querySelector('[data-design-id]')?.dataset.designId || '';
      const designTitle = article?.querySelector('.catalog-design-card__identity strong')?.textContent?.trim()
        || article?.querySelector('strong')?.textContent?.trim()
        || designId.replace(/-/g, ' ');
      return {
        designId,
        designTitle,
        imageUrl: designImage?.currentSrc || designImage?.src || base.imageUrl,
      };
    };

    const selectContext = (context = {}) => {
      active = { ...base, ...context };
      refresh();
      if (active.designTitle) setStatus(`Sharing links are ready for ${active.designTitle}.`);
    };

    if (isPrimaryHub) {
      document.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-design-id]');
        if (!button) return;
        const label = `${button.getAttribute('aria-label') || ''} ${button.textContent || ''}`.toLowerCase();
        if (!label.includes('share')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        selectContext(cardContext(button));
        publish('context_selected', 'catalog');
        sharePanel?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    nativeButtons.forEach((button) => {
      button.hidden = typeof navigator.share !== 'function';
      button.addEventListener('click', async () => {
        const platform = button.dataset.shareNative || 'native';
        publish('intent', platform);
        try {
          await navigator.share({ title: shareTitle(), text: shareText(), url: trackedUrl(platform) });
          publish('completed', platform, 'shared');
          setStatus('Shared — thanks for spreading the word!');
        } catch (error) {
          if (error?.name !== 'AbortError') setStatus('Sharing is unavailable here. Try Copy link instead.');
        }
      });
    });

    copyButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const platform = button.dataset.shareCopy || 'copy';
        publish('intent', platform);
        try {
          await copyText(active.autograph&&platform!=='copy'?fullPost(platform):trackedUrl(platform));
          publish('completed', platform, 'copied');
          if (platform === 'instagram') window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
          if (platform === 'tiktok') window.open('https://www.tiktok.com/', '_blank', 'noopener,noreferrer');
          setStatus(platform === 'copy'
            ? 'Link copied — ready to share!'
            : `${active.autograph?'Caption and link':'Link'} copied. Paste it into ${platform === 'instagram' ? 'Instagram' : 'TikTok'}.`);
        } catch (_) {
          setStatus('Copy did not work. You can still copy the page address from your browser.');
        }
      });
    });

    platformLinks.forEach((link) => {
      link.addEventListener('click', () => publish('intent', link.dataset.sharePlatform));
    });

    refresh();

    const requestedDesign = new URL(window.location.href).searchParams.get('design');
    if (requestedDesign && isPrimaryHub) {
      const selector = `[data-design-id="${CSS.escape(requestedDesign)}"]`;
      const designButton = document.querySelector(`article ${selector}`) || document.querySelector(selector);
      if (designButton) {
        window.setTimeout(() => {
          const selectable = designButton.closest('article')?.querySelector('button[data-design-id]') || designButton;
          selectable.click();
          selectable.closest('article')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 350);
      }
    }
  });
})();
